import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const STORE_API = `${BACKEND_URL}/api/storefront`;

const authHeader = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

export const storeApi = {
  getStore: (code) => axios.get(`${STORE_API}/${code}`).then((r) => r.data),
  getCategories: (code) => axios.get(`${STORE_API}/${code}/categories`).then((r) => r.data),
  getProducts: (code, params = {}) =>
    axios.get(`${STORE_API}/${code}/products`, { params }).then((r) => r.data),
  search: (code, q) =>
    axios.get(`${STORE_API}/${code}/search`, { params: { q } }).then((r) => r.data),
  getProduct: (code, id) =>
    axios.get(`${STORE_API}/${code}/products/${id}`).then((r) => r.data),
  checkout: (code, payload, token) =>
    axios.post(`${STORE_API}/${code}/checkout`, payload, { headers: authHeader(token) }).then((r) => r.data),

  // Customer accounts
  register: (code, payload) =>
    axios.post(`${STORE_API}/${code}/auth/register`, payload).then((r) => r.data),
  login: (code, payload) =>
    axios.post(`${STORE_API}/${code}/auth/login`, payload).then((r) => r.data),
  me: (code, token) =>
    axios.get(`${STORE_API}/${code}/auth/me`, { headers: authHeader(token) }).then((r) => r.data),
  updateProfile: (code, payload, token) =>
    axios.put(`${STORE_API}/${code}/auth/me`, payload, { headers: authHeader(token) }).then((r) => r.data),
  getOrders: (code, token) =>
    axios.get(`${STORE_API}/${code}/auth/orders`, { headers: authHeader(token) }).then((r) => r.data),
};

export const formatMoney = (amount, symbol = "KSh") =>
  `${symbol} ${Number(amount || 0).toLocaleString("en-KE", { maximumFractionDigits: 0 })}`;
